import React, { useEffect, useState, useRef } from 'react'
 import { createPortal } from "react-dom";
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
//Icons 
import { FaCcVisa, FaPhoneAlt } from 'react-icons/fa';
//Utils
import { RenderIf } from '../utils/RenderIf';



function ModalPhoneSaveYappy({ showModalPhone, setShowModalPhone, nextStepYappy, phone }) {

  //Ref for yappy button
  const yappyBtnRef = useRef(null);
  //Refs
  const phoneClientYappy = useRef(null);

   // Set the input value when phone prop changes
  useEffect(() => {
    if (phoneClientYappy?.current) {
      phoneClientYappy.current.value = phone || '';
    }
  }, [phone, showModalPhone]);

  //Use effect to handle the Yappy button events
  useEffect(() => {
    const btnYappy = yappyBtnRef.current;
    const phoneClient = phoneClientYappy.current;
    console.log("btnYappy", btnYappy)

    //We check the yappy button 
    if (btnYappy !== null && btnYappy !== undefined && phoneClient !== null && phoneClient !== undefined) {

      //This is for the event yappy btn success
      btnYappy.addEventListener("eventSuccess", (e) => {
        //setShowModalPhone(false); // Cierra el modal
        console.log("Transaccion ejecutada", e.detail);
        nextStepYappy(btnYappy, phoneClient.value, "success", e.detail);
      });

      //This is for the event yappy btn error
      btnYappy.addEventListener("eventError", (e) => {
        console.log("Transaccion no ejecutada", e.detail)
        nextStepYappy(btnYappy, phoneClient.value, e.detail, 0);
      });

      //This is for the event of the click 
      btnYappy.addEventListener("eventClick", async (e) => {
        nextStepYappy(btnYappy, phoneClient.value, "create", 0);
      });

      btnYappy.addEventListener("eventPayment", (e) => {
        console.log("event payment", e)
      })
    }

    console.log("yappy phone", phone);

  }, [showModalPhone])



  return (
    <>
{/* ==================================================================
    YAPPY — teléfono del cliente — yppy-*
    Portal propio, sin <Modal>.

    Imports:
      import { createPortal } from "react-dom";
      import "./yppy.css";

    El ref phoneClientYappy y el web component <btn-yappy> quedan
    exactamente igual: no se tocan ni su id, ni su theme, ni su ref.
   ================================================================== */}

{showModalPhone && createPortal(
   <div className="yppy-overlay" role="dialog" aria-modal="true" aria-label="Yappy">
      <div className="yppy-dialog" id="modal-phone-yappy">

         {/* ---------------- HEADER ---------------- */}
         <header className="yppy-head">
            <span className="yppy-brand">Yappy</span>
            <button
               type="button"
               className="yppy-close"
               aria-label="Cerrar"
               onClick={() => setShowModalPhone(false)}
            >
               <i className="uil uil-times" />
            </button>
         </header>

         {/* ---------------- BODY ---------------- */}
         <div className="yppy-body">
            <div className="yppy-card">

               <div className="yppy-icon" aria-hidden="true">
                  <FaPhoneAlt />
               </div>

               <h2 className="yppy-title">Ingrese número de teléfono</h2>
               <p className="yppy-text">
                  Se enviará la solicitud de pago al número registrado en Yappy.
               </p>

               <div className="yppy-field">
                  <label className="yppy-label" htmlFor="yppy-phone">Teléfono</label>
                  <input
                     id="yppy-phone"
                     type="tel"
                     inputMode="numeric"
                     className="yppy-input"
                     defaultValue={phone || ''}
                     ref={phoneClientYappy}
                     placeholder="6000-0000"
                  />
               </div>

            </div>
         </div>

         {/* ---------------- FOOTER ---------------- */}
         <div className="yppy-foot">
            <button
               className="yppy-btn yppy-btn--ghost"
               onClick={() => setShowModalPhone(false)}
            >
               Cancelar
            </button>

            <RenderIf isTrue={showModalPhone !== false}>
               <div className="yppy-btn-slot">
                  <btn-yappy
                     theme="blue"
                     id={`yappy-btn`}
                     ref={yappyBtnRef}
                     phone={"66425118"}
                  ></btn-yappy>
               </div>
            </RenderIf>
         </div>

      </div>
   </div>,
   document.body
)}

    </>
  )
}

export default ModalPhoneSaveYappy